<template>
  <div class="r-chart-area">
    <apex-chart
      type="area"
      :height="chartOptions.chart.height || 'auto'"
      :width="chartOptions.chart.width || '100%'"
      :series="series"
      :options="chartOptions"
    />
  </div>
</template>

<script>
/**
 * RChartArea
 *
 * Wrapper for ApexChart's spline area chart with
 * some default chart options. Any options passed
 * in will overwrite defaults.
 */
import merge from 'lodash.merge'

import { getChartColorSet } from '@/utils'

export default {
  name: 'RChartArea',
  props: {
    series: {
      type: Array,
      default: () => []
    },
    options: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    chartOptions () {
      const defaults = {
        chart: {
          fontFamily: "'Figtree', 'proxima-nova', 'Nunito Sans', 'Segoe UI', Arial, sans-serif",
          toolbar: {
            show: true,
            tools: {
              download: true,
              selection: false,
              zoom: false,
              zoomin: false,
              zoomout: false,
              reset: false,
              pan: false
            }
          }
        },
        dataLabels: {
          enabled: false
        },
        colors: getChartColorSet(this.series.map(value => value.name)),
        stroke: {
          curve: 'smooth'
        },
        xaxis: {
          type: 'category',
          categories: []
        },
        yaxis: {
          lines: {
            show: true
          },
          labels: {
            formatter: value => {
              // Remove floating point precision from ints
              if (Number.isInteger(value)) {
                return parseInt(value, 10)
              }
              return value
            }
          }
        }
      }
      return merge(defaults, this.options)
    }
  }
}
</script>
